import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "intro.score.title",
    },
    title1: {
        id: "intro.score.1.title",
    },
    title2: {
        id: "intro.score.2.title",
    },
    title3: {
        id: "intro.score.3.title",
    },
    title4: {
        id: "intro.score.4.title",
    },
    title5: {
        id: "intro.score.5.title",
    },
    title6: {
        id: "intro.score.6.title",
    },
    title7: {
        id: "intro.score.7.title",
    },
    description1: {
        id: "intro.score.1.description",
    },
    description2: {
        id: "intro.score.2.description",
    },
    description3: {
        id: "intro.score.3.description",
    },
    description4: {
        id: "intro.score.4.description",
    },
    description5: {
        id: "intro.score.5.description",
    },
    description6: {
        id: "intro.score.6.description",
    },
});

export default messages;
